import classNames from 'classnames'
import React, { PropsWithChildren } from 'react'
import ReactPlayer from 'react-player'
import { useMediaQuery } from '../../hooks/useMediaQuery'
import projectBannerStyles from './projectBanner.module.scss'

type ProjectVideoBannerProps = {
  videoId: string
  videoType: string
  lightBoxStatus?: boolean
  customClass?: string
}

export const ProjectVideoBanner: React.FC<PropsWithChildren<ProjectVideoBannerProps>> = ({ videoId, videoType,lightBoxStatus, customClass })=> {
  const pauseVideo = lightBoxStatus ? 0 : 1
  const isMobile = useMediaQuery('(max-width: 768px)')

  const videoUrl = videoType === 'youtube' ? `https://www.youtube.com/watch?v=${videoId}` : `https://vimeo.com/${videoId}`

  const containerClasses = [projectBannerStyles[`${customClass}`], projectBannerStyles.playerWrapper]

  switch (videoType) {
  case 'youtube':
    containerClasses.push(projectBannerStyles.youTubePlayerWrapper)
    break
  case 'vimeo':
    containerClasses.push(projectBannerStyles.vimeoPlayerWrapper)
    break
  default:
    break
  }

  return (
    <div className={classNames(containerClasses)}>
      <ReactPlayer
        className={projectBannerStyles.reactPlayer}
        url={videoUrl}
        playing={!!pauseVideo}
        loop={true}
        controls={false}
        muted={true}
        width={isMobile ? '100%' :'106%'}
        height={isMobile ? '100%' : '106%'}
        config={{
          youtube: {
            playerVars: {
              controls: 0,
            },
          },
        }}
      />
    </div>)
}
